import { useFormikContext } from "formik";
import { toAscii } from "src/utils/strings";

export function AsciiField({ name, ...props }) {
  const { setFieldValue, handleBlur, values } = useFormikContext();

  return (
    <input
      {...props}
      name={name}
      value={values[name] ?? ""}
      onBlur={handleBlur}
      onChange={(e) => {
        const next = toAscii(e.target.value);
        setFieldValue(name, next, true); // true => run validation
      }}
    />
  );
}